import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, DollarSign, Users, Music, Clock, AlertTriangle, CheckCircle, Edit, Copy, Send, MoreHorizontal, Target, Mail, FileText, Check, X, TrendingUp, Activity as ActivityIcon } from 'lucide-react';
import { useParams, Link } from 'react-router-dom';
const TABS = ['Overview', 'Artist Matches', 'Outreach', 'Deals', 'Logistics', 'Finance', 'Activity'];
export function EventNeedDetailPage() {
  const {
    eventNeedId
  } = useParams();
  const [activeTab, setActiveTab] = useState('Overview');
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="space-y-6" data-id="element-3167">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-4" data-id="element-3168">
        <div data-id="element-3169">
          <div className="flex items-center space-x-3 mb-2" data-id="element-3170">
            <h1 className="text-2xl font-bold text-zinc-100" data-id="element-3171">
              Saturday Night Indie Showcase
            </h1>
            <span className="px-2.5 py-1 bg-amber-500/10 text-amber-500 text-xs font-medium rounded-full border border-amber-500/20" data-id="element-3172">
              Sourcing
            </span>
          </div>
          <div className="flex items-center space-x-4 text-zinc-400 text-sm" data-id="element-3173">
            <span className="flex items-center" data-id="element-3174">
              <Calendar className="w-4 h-4 mr-1" data-id="element-3175" /> Jul 11, 2026
            </span>
            <span className="flex items-center" data-id="element-3176">
              <MapPin className="w-4 h-4 mr-1" data-id="element-3177" /> Main Room (400 Cap)
            </span>
            <span className="flex items-center" data-id="element-3178">
              <DollarSign className="w-4 h-4 mr-1" data-id="element-3179" /> $500 - $1,500
            </span>
          </div>
        </div>
        <div className="flex items-center space-x-3" data-id="element-3180">
          <button className="px-4 py-2 bg-zinc-900 border border-zinc-800 hover:bg-zinc-800 text-zinc-100 text-sm font-medium rounded-lg transition-colors flex items-center" data-id="element-3181">
            <Copy className="w-4 h-4 mr-2" data-id="element-3182" />
            Duplicate
          </button>
          <button className="px-4 py-2 bg-amber-500 hover:bg-amber-400 text-zinc-900 text-sm font-medium rounded-lg transition-colors flex items-center" data-id="element-3183">
            <Send className="w-4 h-4 mr-2" data-id="element-3184" />
            Send Invites
          </button>
          <button className="p-2 bg-zinc-900 border border-zinc-800 hover:bg-zinc-800 text-zinc-400 rounded-lg transition-colors" data-id="element-3185">
            <MoreHorizontal className="w-4 h-4" data-id="element-3186" />
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex space-x-1 border-b border-zinc-800 overflow-x-auto no-scrollbar" data-id="element-3187">
        {TABS.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`px-4 py-2 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${activeTab === tab ? 'border-amber-500 text-amber-500' : 'border-transparent text-zinc-400 hover:text-zinc-100 hover:border-zinc-700'}`} data-id="element-3188">
            {tab}
          </button>)}
      </div>

      {/* Tab Content */}
      {activeTab === 'Overview' && <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-3189">
          <div className="lg:col-span-2 space-y-6" data-id="element-3190">
            <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3191">
              <div className="flex justify-between items-start mb-4" data-id="element-3192">
                <h3 className="text-lg font-medium text-zinc-100" data-id="element-3193">
                  Event Brief
                </h3>
                <button className="text-zinc-500 hover:text-zinc-300" data-id="element-3194">
                  <Edit className="w-4 h-4" data-id="element-3195" />
                </button>
              </div>
              <p className="text-zinc-300 text-sm leading-relaxed mb-6" data-id="element-3196">
                Looking for a strong local or touring indie rock headliner to
                anchor a Saturday night showcase. Support acts are already
                tentatively held, just need the main draw. Open to co-headline
                situations if the draw makes sense.
              </p>
              <div className="grid grid-cols-2 gap-6" data-id="element-3197">
                <div data-id="element-3198">
                  <p className="text-sm text-zinc-500 mb-1" data-id="element-3199">Target Genres</p>
                  <p className="text-zinc-300" data-id="element-3200">
                    Indie Rock, Post-Punk, Shoegaze
                  </p>
                </div>
                <div data-id="element-3201">
                  <p className="text-sm text-zinc-500 mb-1" data-id="element-3202">Expected Draw</p>
                  <p className="text-zinc-300" data-id="element-3203">250 - 350</p>
                </div>
              </div>
            </div>

            <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3204">
              <h3 className="text-lg font-medium text-zinc-100 mb-4" data-id="element-3205">
                Budget & Compensation
              </h3>
              <div className="grid grid-cols-2 gap-6" data-id="element-3206">
                <div data-id="element-3207">
                  <p className="text-sm text-zinc-500 mb-1" data-id="element-3208">Guarantee Range</p>
                  <p className="text-zinc-100 font-medium" data-id="element-3209">$500 - $1,500</p>
                </div>
                <div data-id="element-3210">
                  <p className="text-sm text-zinc-500 mb-1" data-id="element-3211">Deal Type</p>
                  <p className="text-zinc-300" data-id="element-3212">Guarantee + % of Door (Vs)</p>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6" data-id="element-3213">
            <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3214">
              <h3 className="text-lg font-medium text-zinc-100 mb-4" data-id="element-3215">
                Matching Status
              </h3>
              <div className="flex items-center space-x-4 mb-6" data-id="element-3216">
                <div className="w-12 h-12 rounded-full bg-amber-500/10 flex items-center justify-center" data-id="element-3217">
                  <Target className="w-6 h-6 text-amber-500" data-id="element-3218" />
                </div>
                <div data-id="element-3219">
                  <div className="text-2xl font-bold text-zinc-100" data-id="element-3220">24</div>
                  <p className="text-sm text-zinc-400" data-id="element-3221">Artists Matched</p>
                </div>
              </div>
              <button onClick={() => setActiveTab('Artist Matches')} className="w-full py-2 bg-zinc-900 border border-zinc-800 hover:bg-zinc-800 text-zinc-100 text-sm font-medium rounded-lg transition-colors" data-id="element-3222">
                View Matches
              </button>
            </div>

            <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3223">
              <h3 className="text-lg font-medium text-zinc-100 mb-4" data-id="element-3224">
                Urgency
              </h3>
              <div className="flex items-center space-x-3 text-amber-500" data-id="element-3225">
                <AlertTriangle className="w-5 h-5" data-id="element-3226" />
                <span className="font-medium" data-id="element-3227">Action Needed</span>
              </div>
              <p className="text-sm text-zinc-400 mt-2" data-id="element-3228">
                Event is 45 days away. Recommended to secure headliner within 7
                days.
              </p>
            </div>
          </div>
        </div>}

      {activeTab === 'Artist Matches' && <div className="space-y-6" data-id="element-3229">
          <div className="flex justify-between items-center" data-id="element-3230">
            <h3 className="text-lg font-medium text-zinc-100" data-id="element-3231">Top Matches</h3>
            <button className="text-sm text-amber-500 hover:text-amber-400 font-medium" data-id="element-3232">
              Compare Selected
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-3233">
            {[{
          name: 'Neon Dreams',
          genre: 'Indie Pop',
          fee: '$1k-$2k',
          fit: 95
        }, {
          name: 'The Midnight Echo',
          genre: 'Post-Punk',
          fee: '$800-$1.5k',
          fit: 88
        }, {
          name: 'Crimson Tide',
          genre: 'Indie Rock',
          fee: '$1.2k-$2k',
          fit: 82
        }].map((artist, i) => <div key={i} className="bg-[#14141A] border border-zinc-800 rounded-xl p-4 hover:border-zinc-700 transition-colors" data-id="element-3234">
                <div className="flex justify-between items-start mb-3" data-id="element-3235">
                  <div data-id="element-3236">
                    <h4 className="font-medium text-zinc-100" data-id="element-3237">{artist.name}</h4>
                    <p className="text-xs text-zinc-500" data-id="element-3238">{artist.genre}</p>
                  </div>
                  <span className="text-xs font-medium text-green-500 bg-green-500/10 px-2 py-1 rounded-full" data-id="element-3239">
                    {artist.fit}% Fit
                  </span>
                </div>
                <div className="text-sm text-zinc-400 mb-4" data-id="element-3240">
                  Est. Fee: <span className="text-zinc-300" data-id="element-3241">{artist.fee}</span>
                </div>
                <button className="w-full py-1.5 bg-zinc-900 hover:bg-zinc-800 text-zinc-300 text-sm font-medium rounded-lg transition-colors border border-zinc-800" data-id="element-3242">
                  Invite to Inquire
                </button>
              </div>)}
          </div>
        </div>}

      {activeTab === 'Outreach' && <div className="space-y-6" data-id="element-3243">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-3244">
            <div className="lg:col-span-2 bg-[#14141A] border border-zinc-800 rounded-xl overflow-hidden" data-id="element-3245">
              <div className="p-4 border-b border-zinc-800 flex justify-between items-center bg-zinc-900/30" data-id="element-3246">
                <h3 className="font-medium text-zinc-100" data-id="element-3247">Sent Invites</h3>
                <button className="px-3 py-1.5 bg-amber-500 hover:bg-amber-400 text-zinc-900 text-sm font-medium rounded-lg transition-colors" data-id="element-3248">
                  Draft New Invites
                </button>
              </div>
              <table className="w-full text-left text-sm" data-id="element-3249">
                <thead className="bg-zinc-900/50 border-b border-zinc-800 text-zinc-400" data-id="element-3250">
                  <tr data-id="element-3251">
                    <th className="px-4 py-3 font-medium" data-id="element-3252">Artist</th>
                    <th className="px-4 py-3 font-medium" data-id="element-3253">Sent Date</th>
                    <th className="px-4 py-3 font-medium" data-id="element-3254">Status</th>
                    <th className="px-4 py-3 font-medium" data-id="element-3255">Reply</th>
                    <th className="px-4 py-3 font-medium text-right" data-id="element-3256">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-zinc-800" data-id="element-3257">
                  {[{
                artist: 'Neon Dreams',
                sent: '2 days ago',
                status: 'Replied',
                reply: 'Interested, asking for $1.2k',
                statusColor: 'text-purple-500',
                statusBg: 'bg-purple-500/10'
              }, {
                artist: 'The Midnight Echo',
                sent: '2 days ago',
                status: 'Opened',
                reply: '--',
                statusColor: 'text-blue-500',
                statusBg: 'bg-blue-500/10'
              }, {
                artist: 'Crimson Tide',
                sent: '3 days ago',
                status: 'Passed',
                reply: 'Routing conflict',
                statusColor: 'text-zinc-500',
                statusBg: 'bg-zinc-800'
              }].map((row, i) => <tr key={i} className="hover:bg-zinc-900/50 transition-colors" data-id="element-3258">
                      <td className="px-4 py-3 font-medium text-zinc-100" data-id="element-3259">
                        {row.artist}
                      </td>
                      <td className="px-4 py-3 text-zinc-400" data-id="element-3260">{row.sent}</td>
                      <td className="px-4 py-3" data-id="element-3261">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${row.statusBg} ${row.statusColor}`} data-id="element-3262">
                          {row.status}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-zinc-300 truncate max-w-[150px]" data-id="element-3263">
                        {row.reply}
                      </td>
                      <td className="px-4 py-3 text-right" data-id="element-3264">
                        <button className="text-amber-500 hover:text-amber-400 text-xs font-medium" data-id="element-3265">
                          View Thread
                        </button>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>

            <div className="space-y-6" data-id="element-3266">
              <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3267">
                <h3 className="text-lg font-medium text-zinc-100 mb-4" data-id="element-3268">
                  Invite Template
                </h3>
                <div className="p-4 bg-zinc-900/50 border border-zinc-800 rounded-lg" data-id="element-3269">
                  <div className="flex items-center justify-between mb-3" data-id="element-3270">
                    <span className="text-sm font-medium text-zinc-300" data-id="element-3271">
                      Standard Showcase Invite
                    </span>
                    <button className="text-zinc-500 hover:text-zinc-300" data-id="element-3272">
                      <Edit className="w-4 h-4" data-id="element-3273" />
                    </button>
                  </div>
                  <p className="text-xs text-zinc-400 line-clamp-4" data-id="element-3274">
                    Hey [Artist Name], we're putting together a Saturday night
                    indie showcase on [Date] at [Venue] and think you'd be a
                    great fit to headline. We're looking at a guarantee around
                    [Budget]...
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>}

      {activeTab === 'Deals' && <div className="bg-[#14141A] border border-zinc-800 rounded-xl overflow-hidden" data-id="element-3275">
          <div className="p-4 border-b border-zinc-800 flex justify-between items-center bg-zinc-900/30" data-id="element-3276">
            <h3 className="font-medium text-zinc-100" data-id="element-3277">
              Active Deals for this Need
            </h3>
            <button className="px-3 py-1.5 bg-zinc-900 border border-zinc-800 hover:bg-zinc-800 text-zinc-100 text-sm font-medium rounded-lg transition-colors" data-id="element-3278">
              Create Deal
            </button>
          </div>
          <table className="w-full text-left text-sm" data-id="element-3279">
            <thead className="bg-zinc-900/50 border-b border-zinc-800 text-zinc-400" data-id="element-3280">
              <tr data-id="element-3281">
                <th className="px-4 py-3 font-medium" data-id="element-3282">Artist</th>
                <th className="px-4 py-3 font-medium" data-id="element-3283">Stage</th>
                <th className="px-4 py-3 font-medium" data-id="element-3284">Current Offer</th>
                <th className="px-4 py-3 font-medium" data-id="element-3285">Last Activity</th>
                <th className="px-4 py-3 font-medium text-right" data-id="element-3286">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-800" data-id="element-3287">
              <tr className="hover:bg-zinc-900/50 transition-colors" data-id="element-3288">
                <td className="px-4 py-3 font-medium text-zinc-100" data-id="element-3289">
                  Neon Dreams
                </td>
                <td className="px-4 py-3" data-id="element-3290">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-amber-500/10 text-amber-500" data-id="element-3291">
                    Offer Sent
                  </span>
                </td>
                <td className="px-4 py-3 text-zinc-300" data-id="element-3292">
                  $1,000 Guar. + 80% after $1,500
                </td>
                <td className="px-4 py-3 text-zinc-500" data-id="element-3293">Yesterday</td>
                <td className="px-4 py-3 text-right" data-id="element-3294">
                  <button className="text-amber-500 hover:text-amber-400 text-xs font-medium" data-id="element-3295">
                    Open Deal
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>}

      {activeTab === 'Logistics' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3296">
          <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3297">
            <div className="flex justify-between items-start mb-6" data-id="element-3298">
              <h3 className="text-lg font-medium text-zinc-100" data-id="element-3299">
                Day-of Constraints
              </h3>
              <button className="text-zinc-500 hover:text-zinc-300" data-id="element-3300">
                <Edit className="w-4 h-4" data-id="element-3301" />
              </button>
            </div>
            <div className="space-y-4" data-id="element-3302">
              <div className="flex justify-between items-center py-2 border-b border-zinc-800/50" data-id="element-3303">
                <span className="text-zinc-400 text-sm" data-id="element-3304">Load-in Window</span>
                <span className="text-zinc-100 text-sm font-medium" data-id="element-3305">
                  3:00 PM - 5:00 PM
                </span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-zinc-800/50" data-id="element-3306">
                <span className="text-zinc-400 text-sm" data-id="element-3307">Soundcheck</span>
                <span className="text-zinc-100 text-sm font-medium" data-id="element-3308">
                  5:00 PM - 6:30 PM
                </span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-zinc-800/50" data-id="element-3309">
                <span className="text-zinc-400 text-sm" data-id="element-3310">Doors</span>
                <span className="text-zinc-100 text-sm font-medium" data-id="element-3311">
                  8:00 PM
                </span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-zinc-800/50" data-id="element-3312">
                <span className="text-zinc-400 text-sm" data-id="element-3313">Curfew</span>
                <span className="text-zinc-100 text-sm font-medium" data-id="element-3314">
                  2:00 AM
                </span>
              </div>
            </div>
          </div>

          <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3315">
            <div className="flex justify-between items-start mb-6" data-id="element-3316">
              <h3 className="text-lg font-medium text-zinc-100" data-id="element-3317">
                Production & Hospitality
              </h3>
              <button className="text-zinc-500 hover:text-zinc-300" data-id="element-3318">
                <Edit className="w-4 h-4" data-id="element-3319" />
              </button>
            </div>
            <div className="space-y-4" data-id="element-3320">
              <div className="flex items-center space-x-3" data-id="element-3321">
                <Check className="w-5 h-5 text-green-500" data-id="element-3322" />
                <span className="text-zinc-300 text-sm" data-id="element-3323">
                  In-house PA & Lighting provided
                </span>
              </div>
              <div className="flex items-center space-x-3" data-id="element-3324">
                <Check className="w-5 h-5 text-green-500" data-id="element-3325" />
                <span className="text-zinc-300 text-sm" data-id="element-3326">
                  FOH Engineer provided
                </span>
              </div>
              <div className="flex items-center space-x-3" data-id="element-3327">
                <X className="w-5 h-5 text-red-500" data-id="element-3328" />
                <span className="text-zinc-300 text-sm" data-id="element-3329">
                  No backline provided (Artist must bring)
                </span>
              </div>
              <div className="flex items-center space-x-3" data-id="element-3330">
                <X className="w-5 h-5 text-red-500" data-id="element-3331" />
                <span className="text-zinc-300 text-sm" data-id="element-3332">
                  No venue lodging available
                </span>
              </div>
            </div>
          </div>
        </div>}

      {activeTab === 'Finance' && <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-3333">
          <div className="lg:col-span-2 bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3334">
            <h3 className="text-lg font-medium text-zinc-100 mb-6" data-id="element-3335">
              Budget vs Offers
            </h3>
            <div className="space-y-6" data-id="element-3336">
              <div data-id="element-3337">
                <div className="flex justify-between text-sm mb-2" data-id="element-3338">
                  <span className="text-zinc-400" data-id="element-3339">Total Talent Budget</span>
                  <span className="text-zinc-100 font-medium" data-id="element-3340">$2,000</span>
                </div>
                <div className="w-full h-3 bg-zinc-800 rounded-full overflow-hidden flex" data-id="element-3341">
                  <div className="h-full bg-amber-500" style={{
                width: '50%'
              }} title="Active Offers ($1,000)" data-id="element-3342"></div>
                  <div className="h-full bg-zinc-700" style={{
                width: '50%'
              }} title="Remaining ($1,000)" data-id="element-3343"></div>
                </div>
                <div className="flex justify-between text-xs mt-2 text-zinc-500" data-id="element-3344">
                  <span data-id="element-3345">$1,000 in active offers</span>
                  <span data-id="element-3346">$1,000 remaining</span>
                </div>
              </div>

              <div className="pt-6 border-t border-zinc-800" data-id="element-3347">
                <h4 className="text-sm font-medium text-zinc-100 mb-4" data-id="element-3348">
                  Break-even Calculator
                </h4>
                <div className="grid grid-cols-3 gap-4" data-id="element-3349">
                  <div className="p-3 bg-zinc-900/50 rounded-lg border border-zinc-800/50" data-id="element-3350">
                    <div className="text-xs text-zinc-500 mb-1" data-id="element-3351">
                      Avg Ticket Price
                    </div>
                    <div className="text-lg font-medium text-zinc-100" data-id="element-3352">$20</div>
                  </div>
                  <div className="p-3 bg-zinc-900/50 rounded-lg border border-zinc-800/50" data-id="element-3353">
                    <div className="text-xs text-zinc-500 mb-1" data-id="element-3354">
                      Fixed Expenses
                    </div>
                    <div className="text-lg font-medium text-zinc-100" data-id="element-3355">
                      $500
                    </div>
                  </div>
                  <div className="p-3 bg-zinc-900/50 rounded-lg border border-zinc-800/50" data-id="element-3356">
                    <div className="text-xs text-zinc-500 mb-1" data-id="element-3357">
                      Tickets to Break Even
                    </div>
                    <div className="text-lg font-medium text-amber-500" data-id="element-3358">75</div>
                    <div className="text-[10px] text-zinc-500 mt-0.5" data-id="element-3359">
                      Assumes $1k Guarantee
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}

      {activeTab === 'Activity' && <div className="max-w-2xl bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3360">
          <h3 className="text-lg font-medium text-zinc-100 mb-6" data-id="element-3361">
            Need Timeline
          </h3>
          <div className="space-y-6 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-zinc-800 before:to-transparent" data-id="element-3362">
            {[{
          icon: DollarSign,
          title: 'Offer sent to Neon Dreams',
          time: 'Yesterday, 2:30 PM',
          desc: '$1,000 Guarantee + 80% vs',
          color: 'text-amber-500',
          bg: 'bg-amber-500/10'
        }, {
          icon: Mail,
          title: 'Invited 12 Artists',
          time: '2 days ago',
          desc: 'Sent standard showcase invite',
          color: 'text-blue-500',
          bg: 'bg-blue-500/10'
        }, {
          icon: Target,
          title: 'Generated 24 Matches',
          time: '2 days ago',
          desc: 'Based on Indie Rock, $500-$1500 budget',
          color: 'text-purple-500',
          bg: 'bg-purple-500/10'
        }, {
          icon: ActivityIcon,
          title: 'Event Need Created',
          time: '3 days ago',
          desc: 'Created by Brent Heyl',
          color: 'text-green-500',
          bg: 'bg-green-500/10'
        }].map((item, i) => <div key={i} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-3363">
                <div className="flex items-center justify-center w-10 h-10 rounded-full border border-zinc-800 bg-[#14141A] text-zinc-500 shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-[0_0_0_4px_#14141A] z-10" data-id="element-3364">
                  <div className={`p-1.5 rounded-full ${item.bg}`} data-id="element-3365">
                    <item.icon className={`w-4 h-4 ${item.color}`} data-id="element-3366" />
                  </div>
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl border border-zinc-800 bg-zinc-900/30" data-id="element-3367">
                  <div className="flex items-center justify-between mb-1" data-id="element-3368">
                    <h4 className="font-medium text-zinc-100 text-sm" data-id="element-3369">
                      {item.title}
                    </h4>
                  </div>
                  <p className="text-xs text-zinc-400 mb-2" data-id="element-3370">{item.desc}</p>
                  <time className="text-[10px] font-medium text-zinc-500" data-id="element-3371">
                    {item.time}
                  </time>
                </div>
              </div>)}
          </div>
        </div>}
    </motion.div>;
}